import { useTranslation } from '@mc/i18n'
import Social from '../Social'

const Aside = (props) => {
  const { t } = useTranslation('@mc/next')
  return (
    <aside
      className='col-12 col-lg-1'
      aria-label={t('article.details.social.share')}
    >
      <div className='sticky-top sticky-top--offset-lg mc-py-8'>
        <Social {...props} />
      </div>
    </aside>
  )
}

export default Aside
